
import Vue from 'vue'
import Component from 'vue-class-component'
import { required } from 'vuelidate/lib/validators'
import { Validations } from 'vuelidate-property-decorators'
import EventBus from '@/eventBus'

@Component
export default class ManageContractorAndServices extends Vue {
    @Validations()
    validations = {
        contractorAndService: {
            contractor: { required },
        }
    }
    activeScreen: string = 'main'
    loadingMessage: string = 'Please wait while we create new Contractor/Service'
    loadingTitle: string = 'Saving...'
    additionalSuccessMessage: string = ''
    successMessage: string = 'New Contractor/Service Created Successfully'
    links: Array<object> = [
        {
            text: 'Chart Settings',
            to: '/chart-settings'
        },
        {
            text: 'Manage Contractor/Service',
            active: true
        }
    ]
    error: any = {
        generalMessage: '',
        errors: []
    }
    contractorAndService: any = {
        contractor: '',
    }
    servicesList: string[] = []
    activeItem: any = null
    formErrors: string[] = []


    // METHODS
    checkErrors() {
        this.formErrors = []

        if (this.contractorAndService.contractor.length < 1) {
            this.formErrors.push('Contractor is required')
        }
        if (this.servicesList.length < 1) {
            this.formErrors.push('At least one Service is required')
        }
    }

    newContratorAndServices() {
        this.contractorAndService.contractor = '';
        this.$v.$reset()
    }

    persistData() {
        this.activeScreen = 'loading';
        EventBus.$emit('activeScreen', this.activeScreen)
        if (this.activeItem == null)
            this.saveNew();
        else
            this.update();
    }

    update() {
        this.activeScreen = 'loading'
        EventBus.$emit('activeScreen', this.activeScreen)
        this.loadingMessage = 'Please wait while we update this Contractor/Service'
        this.loadingTitle = 'Updating...'
        var payload = this.createPayload()
        this.$store.dispatch('settingsModule/updateContractorAndServices', {id: this.activeItem.id, contractorAndServices: payload})
            .then((res: any) => {
                this.activeScreen = 'successNoGotIt'
                EventBus.$emit('activeScreen', this.activeScreen)
                this.additionalSuccessMessage = ''
                this.successMessage = 'Contractor/Service Updated Successfully'
            }
            ).catch((err: any) => {
                this.activeScreen = 'error'
                EventBus.$emit('activeScreen', this.activeScreen)
                this.error.generalMessage = err.response.data.data
            })
    }

    createPayload() {
        return {
            contractor: this.contractorAndService.contractor,
            services: this.servicesList
        }
    }

    saveNew() {
        var payload = this.createPayload()
        
        this.$store.dispatch('settingsModule/createContractorAndServices', payload)
            .then((res: any) => {
                this.activeScreen = 'successRemain'
                EventBus.$emit('activeScreen', this.activeScreen)
                this.additionalSuccessMessage = 'You can now use the new Contractor/Service'
                this.successMessage = 'Successfully Created ' + payload.contractor
                this.newContratorAndServices()
            }
            ).catch((err: any) => {
                this.activeScreen = 'error'
                EventBus.$emit('activeScreen', this.activeScreen)
                this.error.generalMessage = err.response.data.data
            })
    }

    get isButtonDisabled(): boolean {
        if (this.formErrors.length > 0) {
            return true
        } else {
            return false
        }
    }

    get fetchContractorAndServices() {
        return this.$store.dispatch('settingsModule/getContractorAndServices')
    }

    get currentContractorAndServices() {
        return this.$store.getters['settingsModule/getContractorAndServices']
    }

    // CREATED
    created() {
        this.fetchContractorAndServices.then(() => {
            if (this.$route.query.id) {
                this.activeItem = this.currentContractorAndServices.find((i: any) => i.id == this.$route.query.id)

                this.contractorAndService.id = this.activeItem.id;
                this.contractorAndService.contractor = this.activeItem.contractor,
                this.servicesList = this.activeItem.services;
            } else {
                this.checkErrors()
            }
        });
        this.checkErrors()
    }
}

